import { render, staticRenderFns } from "./ChartBP.vue?vue&type=template&id=9aa9742e&scoped=true"
import script from "./ChartBP.vue?vue&type=script&lang=js"
export * from "./ChartBP.vue?vue&type=script&lang=js"
import style0 from "./ChartBP.vue?vue&type=style&index=0&id=9aa9742e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa9742e",
  null
  
)

export default component.exports